import ApiService from "@/core/services/ApiService";

class AuthService {
    
    //crear nueva cuenta
    public static createUser(data: any) {
        return ApiService.post('public/account/new', data)
    }

    //activar cuenta
    public static activateAccount(code){
        return ApiService.get('public/account/activate', code)
    }

    //recuperar contraseña
    public static forgotPassword(data: any) {
        return ApiService.post('public/account/forgot-password', data)
    }

    //verifi hash for reset password
    public static checkHashResetPassword(code: any){
        return ApiService.get('public/account/check-hash-password', code)
    }

    public static changePassword(data: any){
        return ApiService.post('public/account/change-password', data)
    }
}

export default AuthService